import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-align-left"><path d="M20.25 3.75H21V3L20.25 3V3.75ZM3.75 3.75L3.75 3L3 3V3.75H3.75ZM3.75 20.25H3V21H3.75V20.25ZM20.25 20.25V21H21V20.25H20.25ZM6.99999 16.25V17H8.49999V16.25H6.99999ZM8.49999 7.75V7H6.99999V7.75H8.49999ZM20.25 3L3.75 3L3.75 4.5L20.25 4.5V3ZM3 3.75V20.25H4.5V3.75H3ZM3.75 21H20.25V19.5H3.75V21ZM21 20.25V3.75H19.5V20.25H21ZM8.49999 16.25V7.75H6.99999V16.25H8.49999Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutAlignLeft;
